import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-content-loader',
  templateUrl: './contentLoader.component.html',
  imports: [CommonModule],
  styleUrls: ['./contentLoader.component.scss']
})
export class ContentLoaderComponent {
  @Input() visible = false;
}
